import { render, staticRenderFns } from "./PatientFilter.vue?vue&type=template&id=0175c75a&scoped=true"
import script from "./PatientFilter.vue?vue&type=script&lang=js"
export * from "./PatientFilter.vue?vue&type=script&lang=js"
import style0 from "./PatientFilter.vue?vue&type=style&index=0&id=0175c75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0175c75a",
  null
  
)

export default component.exports